import React from 'react';
import { Target, Weight, TrendingDown } from 'lucide-react';

const GoalSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  weightGoals 
}) => {
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Target className="w-5 h-5 mr-2 text-emerald-500" />
        Цель по снижению веса
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Цель */}
        <div className="col-span-full">
          <label htmlFor="goal" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Выберите цель
          </label>
          <select
            id="goal"
            name="goal"
            value={formData.goal}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.goal ? 'input-error' : ''}`}
          >
            <option value="" disabled>Выберите цель</option>
            {weightGoals.map((goal) => (
              <option key={goal.id} value={goal.id}>
                {goal.name}
              </option>
            ))}
          </select>
          {errors.goal && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.goal}
            </p>
          )}
          {formData.goal && (
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              {weightGoals.find(g => g.id === formData.goal)?.description || ''}
            </p>
          )}
        </div>

        {/* Отображаем поле для ввода скорости снижения веса только для целей похудения */}
        {(formData.goal === 'mild_loss' || formData.goal === 'moderate_loss' || formData.goal === 'aggressive_loss') && (
          <div className="col-span-full">
            <label htmlFor="weightLossRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
              <TrendingDown className="w-4 h-4 mr-2 text-emerald-500" />
              Желаемая скорость снижения веса (кг/неделю)
            </label>
            <input
              type="text"
              id="weightLossRate"
              name="weightLossRate"
              value={formData.weightLossRate}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.weightLossRate ? 'input-error' : ''}`}
              placeholder="Например: 0.5"
            />
            {errors.weightLossRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.weightLossRate}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
              Рекомендуемая скорость: 0.5-1 кг в неделю. Более быстрое снижение веса может быть менее устойчивым в долгосрочной перспективе.
            </p>
          </div>
        )}
      </div>

      {/* Информационный блок по целям */}
      <div className="mt-4 p-3 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg border border-emerald-200 dark:border-emerald-800">
        <div className="flex items-start">
          <Weight className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-1">
              Важная информация о снижении веса
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400">
              Безопасным и устойчивым темпом снижения веса считается 0.5-1 кг в неделю. 
              Это соответствует дефициту примерно 500-1000 ккал в день. Более агрессивное 
              снижение может привести к потере мышечной массы, замедлению метаболизма 
              и быстрому возвращению сброшенного веса. Всегда консультируйтесь с врачом 
              перед началом программы снижения веса.
            </p>
          </div>
        </div>
      </div>

      {formData.goal !== 'maintain' && (
        <div className="mt-4">
          <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            {formData.goal.includes('loss') ? 'Дефицит калорий для снижения веса' : 'Профицит калорий для набора веса'}:
          </h4>
          <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
            <div 
              className={`h-2.5 rounded-full ${formData.goal.includes('loss') ? 'bg-rose-500' : 'bg-blue-500'}`} 
              style={{ 
                width: `${formData.goal === 'mild_loss' || formData.goal === 'mild_gain' ? '25%' : 
                        formData.goal === 'moderate_loss' || formData.goal === 'moderate_gain' ? '50%' : 
                        formData.goal === 'aggressive_loss' ? '100%' : '0%'}`
              }}
            ></div>
          </div>
          <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1">
            <span>Минимум</span>
            <span>Рекомендуемый</span>
            <span>Максимум</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoalSection;